import { useEffect } from 'react';

import Dropdown from '../../../components/dropdowns/dropdown';

export default function QuestionTypeDropdown({ question, params, onChange, validation, addError, error, showErrors, setValidation, handleQuestionChange, getQuestionValue, blockId, sectionId }) {    
    const onComponentChange = (e, index) => {
        onChange(e, blockId, question.id, index, question);

        setError(e);
    }

    const setError = (e = null) => {
        const { value } = e !== null ? e : params;
        const val = value !== null ? value : '';

        if (question.response_required) {
            addError(val.length == 0, ['You need to select an option'], sectionId, question.id);
        }
    }

    useEffect(() => {
        setError();
    }, [])

    const newParams = {
        placeholder: question.dropdown_title,
        items: question.dropdown.map(({ item }) => ({ label: item, value: item })),
    }

    params = Object.assign({}, newParams, params);

    return <Dropdown onChange={onComponentChange} error={showErrors && error} { ...params }/>
}